import { getTrackFlights, toArray } from "./trackUtils";

function asId(value) {
    return value == null ? null : String(value);
}

function getMatchSourceId(match) {
    return asId(match?.source_operation_id ?? match?.source_flight_id);
}

function getReferenceFlightSourceId(flight) {
    return asId(flight?.source_operation_id ?? flight?.source_flight_id ?? flight?.id);
}

export function countUnmatchedFlightDetails(editingTrack, referenceTrack, matches = []) {
    const matchedDraftFlightIds = new Set();
    const matchedSourceIds = new Set();

    toArray(matches).forEach((match) => {
        const draftFlightId = asId(match?.schedule_draft_flight_id);
        const sourceId = getMatchSourceId(match);
        if (draftFlightId) {
            matchedDraftFlightIds.add(draftFlightId);
        }
        if (sourceId) {
            matchedSourceIds.add(sourceId);
        }
    });

    const editingUnmatched = getTrackFlights(editingTrack).filter((flight) => !matchedDraftFlightIds.has(asId(flight?.id))).length;
    const referenceUnmatched = getTrackFlights(referenceTrack).filter((flight) => !matchedSourceIds.has(getReferenceFlightSourceId(flight))).length;
    return {
        editing: editingUnmatched,
        reference: referenceUnmatched,
        total: editingUnmatched + referenceUnmatched,
    };
}

export function countUnmatchedFlights(editingTrack, referenceTrack, matches = []) {
    return countUnmatchedFlightDetails(editingTrack, referenceTrack, matches).total;
}

export function formatUnmatchedCompareReason(unmatchedCount, unmatchedDetails = {}, explicitUnmatchedCount = 0) {
    const segments = [];
    if (unmatchedDetails.editing > 0) {
        segments.push(`草稿航班 ${unmatchedDetails.editing} 个`);
    }
    if (unmatchedDetails.reference > 0) {
        segments.push(`执行航班 ${unmatchedDetails.reference} 个`);
    }
    if (explicitUnmatchedCount > 0) {
        segments.push(`待处理记录 ${explicitUnmatchedCount} 条`);
    }
    const suffix = segments.length ? `（${segments.join("，")}）` : unmatchedCount > 0 ? `（${unmatchedCount} 个）` : "";
    return `仍有未匹配航班${suffix}，需处理后才能确认匹配`;
}
